import { cloneDeep } from "lodash";
import * as moment from "moment";
import { validateMobileNumber } from "utils";
import Helper from "utils/helper";
import { v4 as uuidv4 } from "uuid"; // Import UUID library
export const fieldDefaultState = {
  officeIds: [],
  errors: {},
  employmentDate: moment().toDate(),
  staffType: "",
  designationId: "",
  performanceReviewId: null,
  hourlyRate: 0,
  annualSalary: 0,
  commission_radio: "1",
  commission_input_text: "",
  bonus_input_text: "",
  bonus_input_radio: "1",
  bonus_signing_input_text: "0",
  bonus_annual_bonus_input_text: "0",
  vacationPaidOff: "0",
  TravelAllowance: "0",
  EducationAllowance: "0",
  UniformAllowance: "0",
  OtherAllowance: "0",
  DepartmentId: null,
  ReportToId: null,
  isAdmin: false,
  showHourlyRate: false,
  isDoctor: false,
  isReceptionist: false,
  isOrderManager: false,
  schedule: [],
  scheduleWeek: [],
  statusType: null,
  defatultSelected: null,
  IsInventoryManager: false,
  leaves: [],
  tooltipObj: {
    tooltipAdmin: false,
    tooltipDoctor: false,
    tooltipReceptionist: false,
    tooltipInventory: false,
    tooltipOrder: false,
    pickColorInfo: false,
  },
};
export const fieldDefaultEmptyState = {
  officeIds: [],
  errors: {},
  employmentDate: null,
  staffType: "",
  designationId: "",
  performanceReviewId: null,
  hourlyRate: "",
  annualSalary: "",
  commission_radio: "",
  commission_input_text: "",
  bonus_input_text: "",
  bonus_input_radio: "",
  bonus_signing_input_text: "",
  bonus_annual_bonus_input_text: "",
  vacationPaidOff: "",
  TravelAllowance: "",
  EducationAllowance: "",
  UniformAllowance: "",
  OtherAllowance: "",
  DepartmentId: null,
  ReportToId: null,
  isAdmin: false,
  showHourlyRate: false,
  isDoctor: false,
  isReceptionist: false,
  isOrderManager: false,
  schedule: "",
  scheduleWeek: [],
  statusType: null,
  defatultSelected: null,
  IsInventoryManager: false,
  leaves: [],
  tooltipObj: {
    tooltipAdmin: false,
    tooltipDoctor: false,
    tooltipReceptionist: false,
    tooltipInventory: false,
    tooltipOrder: false,
    pickColorInfo: false,
  },
};
export const payloadGenerate = ({
  state,
  profile,
  removeAsAdminFromAllOffices,
  transferWorkItemsTo,
  globalStaffPage,
}) => {
  const {
    staffId,
    profileColor,
    inviteId,
    officeId,
    title,
    firstName,
    lastName,
    emailId,
    contactNumber,
    statusType,
    fields,
  } = state;

  /** ----------------------------------------
   * Common builder helpers
   * -------------------------------------- */

  const buildCommonDetails = () => ({
    userId: profile.id,
    officeId: globalStaffPage ? undefined : officeId,
    honorific: title,
    firstName: firstName.trim(),
    lastName: lastName.trim(),
    colourCode: profileColor,
    emailId: emailId.trim(),
  });
  const buildStaffField = (field) => {
    const {
      staffType,
      designationId,
      isAdmin,
      isDoctor,
      isReceptionist,
      schedule,
      hourlyRate,
      performanceReviewId,
      isOrderManager,
      showHourlyRate,
      annualSalary,
      commission_radio,
      commission_input_text,
      bonus_input_text,
      bonus_input_radio,
      bonus_annual_bonus_input_text,
      bonus_signing_input_text,
      EducationAllowance,
      OtherAllowance,
      UniformAllowance,
      TravelAllowance,
      vacationPaidOff,
      DepartmentId,
      ReportToId,
      leaves,
      officeIds,
      employmentDate,
      IsInventoryManager,
    } = field;
    const innerPayload = {
      employmentDate: moment(employmentDate).format("YYYY-MM-DD"),
      staffType: Number(staffType),
      designationId: Number(designationId),
      isAdmin,
      isDoctor,
      IsOrderManager: isOrderManager,
      isReceptionist,
      IsInventoryManager,
      schedule: String(schedule),
      AnnualSalary: Number(annualSalary).toFixed(2),
      Commission: commission_input_text,
      Bonus: bonus_input_text,
      AnnualBonus: bonus_annual_bonus_input_text,
      SigningBonus: bonus_signing_input_text,
      TravelAllowance,
      EducationAllowance,
      UniformAllowance,
      OtherAllowance,
      vacationPaidOff,
      CommissionType: Number(commission_radio),
      BonusType: Number(bonus_input_radio),
      DepartmentId: DepartmentId?.id ?? null,
      ReportToId: ReportToId?.userId ?? null,
      leaves: leaves.map((l) => ({
        leaveTypeId: l.typeId,
        leaves: Number(l.value),
      })),
      hourlyRate: parseFloat(hourlyRate),
      performanceReviewId: Number(performanceReviewId),
      canAdminSeeHourlyRate: isAdmin && showHourlyRate,
    };
    if (globalStaffPage) {
      innerPayload.officeIds = officeIds.map((res) => res?.id);
    }
    return innerPayload;
  };

  const commonDetails = buildCommonDetails();
  const staffField = globalStaffPage
    ? { officeAssignments: fields.map(buildStaffField) }
    : buildStaffField(fields[0]);

  /** ----------------------------------------
   * Payload assembly
   * -------------------------------------- */

  const basePayload = {
    staffId,
    removeAsAdminFromAllOffices,
    transferWorkItemsTo,
    ...commonDetails,
    ...staffField,
    ...(contactNumber && { contactNumber: contactNumber.trim() }),
    ...(state?.sikkaProviderId && {
      SikkaProviderId: state.sikkaProviderId,
    }),
  };
  if (globalStaffPage) {
    delete basePayload.staffId;
  }
  /** ----------------------------------------
   * INVITE FLOW
   * -------------------------------------- */

  if (statusType === 3) {
    const invitePayload = {
      inviteId,
      ...commonDetails,
      ...staffField,
      ...(contactNumber && { contactNumber: contactNumber.trim() }),
    };
    return invitePayload;
  }
  return basePayload;
  /** ----------------------------------------
   * STAFF UPDATE / CREATE FLOW
   * -------------------------------------- */
};

export const isValidFields = ({
  t,
  state,
  // InputChange,
  setState,
  // location,
  globalStaffPage,
}) => {
  const { emailId, contactNumber, title, firstName, lastName, profileColor } =
    state;
  const errors = {};
  let isValid = true;

  if (!title) {
    errors.title = t("form.errors.emptySelection", { field: t("title") });
    isValid = false;
  }

  if (!firstName) {
    errors.firstname = t("form.errors.emptyField", {
      field: t("form.fields.firstName"),
    });
    isValid = false;
  }

  if (!lastName) {
    errors.lastname = t("form.errors.emptyField", {
      field: t("form.fields.lastName"),
    });
    isValid = false;
  }

  if (!emailId) {
    errors.emailId = t("form.errors.emptyField", {
      field: t("form.fields.emailAddress"),
    });
    isValid = false;
  }

  if (!profileColor) {
    errors.profileColor = t("form.errors.emptySelection", {
      field: t("color"),
    });
    isValid = false;
  }

  if (emailId && !Helper.validateEmail(emailId)) {
    errors.emailId = t("form.errors.invalidValue", {
      field: t("form.fields.emailAddress"),
    });
    isValid = false;
  }

  if (state?.sikkaUserId && !contactNumber) {
    errors.contactNumber = t("form.errors.emptyField", {
      field: t("form.fields.contactNumber"),
    });
    isValid = false;
  }
  if (
    state?.sikkaUserId &&
    contactNumber &&
    !validateMobileNumber(contactNumber)
  ) {
    errors.contactNumber = t("form.errors.invalidValue", {
      field: t("form.fields.contactNumber"),
    });
    isValid = false;
  }
  const fields = state.fields.map((field) => {
    const {
      staffType,
      designationId,
      schedule,
      employmentDate,
      leaves,
      errors: errorNew,
      officeIds,
    } = field;
    if (!employmentDate) {
      errorNew.employmentDate = t("form.errors.emptyField", {
        field: t("form.fields.employmentDate"),
      });
      isValid = false;
    } else {
      delete errorNew.employmentDate;
    }

    if (globalStaffPage && !officeIds?.length) {
      errorNew.officeIds = t("staff.enterOfficeName");
      isValid = false;
    } else {
      delete errorNew.officeIds;
    }

    if (!staffType) {
      errorNew.staffType = t("form.errors.emptySelection", {
        field: t("form.fields.staffType"),
      });
      isValid = false;
    } else {
      delete errorNew.staffType;
    }

    if (!designationId) {
      errorNew.designationId = t("form.errors.emptySelection", {
        field: t("form.fields.designation"),
      });
      isValid = false;
    } else {
      delete errorNew.designationId;
    }

    if (schedule.length <= 0) {
      errorNew.schedule = t("form.errors.emptySelection", {
        field: t("form.fields.schedule"),
      });
      isValid = false;
    } else {
      delete errorNew.schedule;
    }

    leaves.forEach((l) => {
      if (!l.value) {
        isValid = false;
        l.error = t("form.errors.invalidValue2");
      } else if (!/^\d+$/.test(l.value)) {
        isValid = false;
        l.error = t("form.errors.numericValue");
      } else if (parseInt(l.value) > 366) {
        isValid = false;
        l.error = t("form.errors.maxLeaveCount");
      } else if (parseInt(l.value) < 0) {
        isValid = false;
        l.error = t("form.errors.minLeaveCount");
      } else {
        delete l.error;
      }
    });
    return field;
  });
  // InputChange({
  //   target: {
  //     name: "fields",
  //     value: fields,
  //   },
  // });
  // updateFieldState();

  setState((prev) => ({ ...prev, errors, fields }));
  return isValid;
};

const schedules = [
  { value: "7", label: "S", active: false },
  { value: "1", label: "M", active: false },
  { value: "2", label: "T", active: false },
  { value: "3", label: "W", active: false },
  { value: "4", label: "T", active: false },
  { value: "5", label: "F", active: false },
  { value: "6", label: "S", active: false },
];
export const editPreSetterValues = ({
  updateState,
  locationState,
  // state,
  // staffDesignation,
  pathname,
}) => {
  const locationStateStaffDetail = locationState?.staffDetail;

  if (
    pathname.includes("editStaff") &&
    locationStateStaffDetail &&
    Object.keys(locationStateStaffDetail).length > 0
  ) {
    const scheduleDays = locationStateStaffDetail?.schedule?.split(",") || [];
    const scheduleWeek = schedules.map((item) => {
      item.active = scheduleDays.includes(item.value);
      return item;
    });

    updateState({
      inviteId: locationStateStaffDetail.inviteId,
      title: locationStateStaffDetail.honorific,
      userId: locationStateStaffDetail.staffMemberId,
      firstName: locationStateStaffDetail.firstName,
      lastName: locationStateStaffDetail.lastName,
      emailId: locationStateStaffDetail.emailId,
      staffId: locationStateStaffDetail.staffId,
      sikkaProviderId: locationStateStaffDetail?.sikkaProviderId,
      contactNumber: locationStateStaffDetail?.contactNumber,
      statusType: locationStateStaffDetail.type,
      profileColor: locationStateStaffDetail.colourCode,
      address: locationStateStaffDetail.address || "",
      socialSecurityNumber: locationStateStaffDetail.socialSecurityNumber || "",
      fields: [
        {
          ...cloneDeep(fieldDefaultState),
          key: uuidv4(),
          employmentDate: locationStateStaffDetail?.employmentDate
            ? moment(locationStateStaffDetail?.employmentDate).toDate()
            : null,
          staffType: locationStateStaffDetail.staffRoleId,
          designationId: locationStateStaffDetail.designationId,
          isAdmin: locationStateStaffDetail.isAdmin,
          isOrderManager: locationStateStaffDetail.isOrderManager,
          isDoctor: locationStateStaffDetail?.sikkaProviderId
            ? true
            : locationStateStaffDetail.isDoctor,
          isReceptionist: locationStateStaffDetail?.sikkaProviderId
            ? false
            : locationStateStaffDetail.isReceptionist,
          IsInventoryManager: locationStateStaffDetail.isInventoryManager,
          scheduleWeek: scheduleWeek,
          schedule: scheduleDays,
          statusType: locationStateStaffDetail.type,
          profileColor: locationStateStaffDetail.colourCode,
          hourlyRate: locationStateStaffDetail.hourlyRate,
          showHourlyRate: locationStateStaffDetail.canAdminSeeHourlyRate,
          performanceReviewId:
            locationStateStaffDetail.performanceReviewId > 0
              ? locationStateStaffDetail.performanceReviewId
              : null,
          annualSalary:
            locationStateStaffDetail?.annualSalary?.toString() || "0",
          commission_radio:
            locationStateStaffDetail?.commissionType?.toString() || "1",
          commission_input_text: locationStateStaffDetail?.commission || "0",
          bonus_input_text: locationStateStaffDetail?.bonus || "0",
          bonus_input_radio:
            locationStateStaffDetail?.bonusType?.toString() || "1",
          bonus_signing_input_text:
            locationStateStaffDetail?.signingBonus || "0",
          bonus_annual_bonus_input_text:
            locationStateStaffDetail?.annualBonus || "0",
          vacationPaidOff: locationStateStaffDetail?.vacationPaidOff || "0",
          TravelAllowance: locationStateStaffDetail?.travelAllowance || "0",
          EducationAllowance:
            locationStateStaffDetail?.educationAllowance || "0",
          UniformAllowance: locationStateStaffDetail?.uniformAllowance || "0",
          OtherAllowance: locationStateStaffDetail?.otherAllowance || "0",
          DepartmentId: locationStateStaffDetail?.departmentId
            ? {
                id: locationStateStaffDetail?.departmentId,
                name: locationStateStaffDetail?.departmentName,
              }
            : null,
          ReportToId: locationStateStaffDetail?.reportToId
            ? {
                userId: locationStateStaffDetail?.reportToId,
                user: { firstName: locationStateStaffDetail?.reportToName },
              }
            : null,
        },
      ],
    });
  }

  // if (locationState?.sikkaUserId) {
  //   updateState({
  //     firstName: locationState?.firstName,
  //     lastName: locationState?.lastName,
  //     emailId: locationState?.emailId,
  //     contactNumber: locationState?.contactNumber,
  //     sikkaUserId: locationState?.sikkaUserId,
  //     isDoctor: true,
  //     isReceptionist: false,
  //   });
  // }

  // if (!pathname.includes("/AddStaff") && staffDesignation?.designations_list) {
  //   if (locationStateStaffDetail?.designationId) {
  //     const selectedValue = staffDesignation?.designations_list?.find(
  //       (designation) =>
  //         designation.id === locationStateStaffDetail?.designationId
  //     );
  //     if (selectedValue) {
  //       return updateState({
  //         designationId: selectedValue.id,
  //         defatultSelected: selectedValue,
  //       });
  //     }
  //   }
  //   const defatultSelected = staffDesignation.designations_list.filter(
  //     (item) => item.isDefaultRole
  //   );
  //   if (defatultSelected && state.isProps && defatultSelected.length > 0) {
  //     updateState({
  //       designationId: defatultSelected[0].id,
  //       defatultSelected: defatultSelected,
  //     });
  //   }
  // }
};

export const  generatePayloadForBulk = ({ state }) => {
  const { fields, title, firstName, lastName, contactNumber, profileColor } =
    state;
  const {
    staffType,
    designationId,
    isAdmin,
    isDoctor,
    isReceptionist,
    schedule,
    hourlyRate,
    performanceReviewId,
    isOrderManager,
    showHourlyRate,
    annualSalary,
    commission_radio,
    commission_input_text,
    bonus_input_text,
    bonus_input_radio,
    bonus_annual_bonus_input_text,
    bonus_signing_input_text,
    EducationAllowance,
    OtherAllowance,
    UniformAllowance,
    TravelAllowance,
    vacationPaidOff,
    DepartmentId,
    ReportToId,
    leaves,
    employmentDate,
    IsInventoryManager,
  } = fields[0];

  const payload = {
    UserOfficeDetails: {
      employmentDate: employmentDate
        ? moment(employmentDate).format("YYYY-MM-DD")
        : null,
      isEmploymentDateEdited: !!employmentDate,
      staffRoleId: +staffType,
      isStaffRoleIdEdited: !!+staffType,
      designationId: designationId || null,
      isDesignationIdEdited: !!designationId,
      departmentId: DepartmentId?.id || null,
      isDepartmentIdEdited: !!DepartmentId?.id,
      schedule: schedule.toString(),
      isScheduleEdited: schedule.length > 0,
      reportToId: ReportToId?.userId || null,
      isReportToIdEdited: !!ReportToId?.userId,
      hourlyRate: parseFloat(hourlyRate.trim()),
      isHourlyRateEdited: !!hourlyRate.trim(),
      annualSalary: Number(annualSalary.trim()).toFixed(2),
      isAnnualSalaryEdited: !!annualSalary.trim(),
      commission: commission_input_text.trim(),
      isCommissionEdited: !!commission_input_text.trim(),
      commissionType: Number(commission_radio),
      isCommissionTypeEdited: !!Number(commission_radio),
      bonus: bonus_input_text.trim(),
      isBonusEdited: !!bonus_input_text.trim(),
      bonusType: Number(bonus_input_radio),
      isBonusTypeEdited: !!Number(bonus_input_radio),
      annualBonus: bonus_annual_bonus_input_text.trim(),
      isAnnualBonusEdited: !!bonus_annual_bonus_input_text.trim(),
      signingBonus: bonus_signing_input_text.trim(),
      isSigningBonusEdited: !!bonus_signing_input_text.trim(),
      travelAllowance: TravelAllowance.trim(),
      isTravelAllowanceEdited: !!TravelAllowance.trim(),
      educationAllowance: EducationAllowance.trim(),
      isEducationAllowanceEdited: !!EducationAllowance.trim(),
      uniformAllowance: UniformAllowance.trim(),
      isUniformAllowanceEdited: !!UniformAllowance.trim(),
      otherAllowance: OtherAllowance.trim(),
      isOtherAllowanceEdited: !!OtherAllowance.trim(),
      vacationPaidOff: vacationPaidOff.trim(),
      isVacationPaidOffEdited: !!vacationPaidOff.trim(),
      leaves: leaves.map((l) => ({
        leaveTypeId: l.typeId,
        leaves: Number(l.value.trim()),
        isEdited: !!l.value.trim(),
      })),
      isLeavesEdited: leaves.some((l) => !!l.value.trim()),
      isAdmin: isAdmin,
      canAdminSeeHourlyRate: isAdmin && showHourlyRate,
      isCanAdminSeeHourlyRate: isAdmin && showHourlyRate,
      performanceReviewId: Number(performanceReviewId),
      isPerformanceReviewId: !!Number(performanceReviewId),
      isIsAdminEdited: isAdmin,
      isDoctor: isDoctor,
      isIsDoctorEdited: isDoctor,
      isReceptionist: isReceptionist,
      isIsReceptionistEdited: isReceptionist,
      isOrderManager: isOrderManager,
      isIsOrderManagerEdited: isOrderManager,
      isInventoryManager: IsInventoryManager,
      isIsInventoryManagerEdited: IsInventoryManager,
    },
    IsUserOfficeDetailsEdited: false,
    UserPersonalDetails: {
      honorific: title,
      IsHonorificEdited: !!title,
      FirstName: firstName.trim(),
      IsFirstNameEdited: !!firstName.trim(),
      LastName: lastName.trim(),
      IsLastNameEdited: !!lastName.trim(),
      ContactNumber: contactNumber.trim(),
      IsContactNumberEdited: !!contactNumber.trim(),
      ColourCode: profileColor,
      IsColourCodeEdited: !!profileColor,
    },
    IsUserPersonalDetailsEdited: false,
    IsAllOffice: true,
    userIds: [],
    officeIds: [],
  };
  const check = [
    { a: "IsUserOfficeDetailsEdited", b: "UserOfficeDetails" },
    { a: "IsUserPersonalDetailsEdited", b: "UserPersonalDetails" },
  ];
  check.forEach(({ a, b }) => {
    payload[a] = Object.entries(payload[b]).some(([key, value]) => {
      if (key.startsWith("is") || key.startsWith("Is")) {
        return value;
      }
      return false;
    });
  });

  return {
    payload,
    submit:
      payload.IsUserPersonalDetailsEdited || payload.IsUserOfficeDetailsEdited,
  };
};
